export default __webpack_public_path__ + "static/media/stjerne.3cd09f8c.svg";